import axios from "axios";
import {
  GetSuppliesDetailRequestBody,
  CupsDetail,
} from "../../models/suppliesDetail/suppliesDetail.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";

const getSuppliesDetail = async (
  requestBody: GetSuppliesDetailRequestBody,
  token: string,
  abortSignal: AbortSignal
): Promise<CupsDetail> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_CUPS_DETAIL, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

export { getSuppliesDetail };
